import { Switch } from '@headlessui/react';
import cn from '@/lib/clsxm';
import Props from '@/components/@base/input/check-box/type';
import Container from '@/components/@base/container';
import { COLOR_ENUM } from '@/components/@base/@types';
import FontIcon from '@/components/@base/font-icon';

export default function CheckBox({ onChange, checked = false, text, color, loading }: Props) {
  return (
    <Switch checked={checked} disabled={loading} onChange={onChange} className="relative -mb-2 outline-none">
      {loading && <div
        className="absolute -right-8 top-1 border-4 w-6 h-6 border-t-transparent rounded-full animate-spin border-t-gray-700 border-gray-300"
      />}
      <label className='inline-flex cursor-pointer items-center'>
        <Container
          className={cn(
            "relative h-[30px] w-12 rounded-full bg-[#acadad] after:absolute after:start-[2px] after:top-[2px] after:h-[26px] after:w-[26px] after:rounded-full after:shadow-[0px_2px_4px_0px_#00000014]  after:bg-white dark:after:bg-black after:transition-all after:content-[''] ",
            checked &&
            'bg-black dark:bg-white after:translate-x-full after:border-white peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rtl:after:-translate-x-[18px]',
            color === COLOR_ENUM.SUCCESS &&
            checked &&
            'bg-green-600 after:translate-x-full after:border-white peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-green-300 rtl:after:-translate-x-[18px]',
          )}
        >
          <FontIcon icon="icon-check-bold" className={cn('absolute left-1.5 z-10 top-0 text-black dark:text-white text-lg', !checked && 'opacity-0')}/>
        </Container>
        <span className='ms-3 text-sm font-medium text-gray-900'>
          {text}
        </span>
      </label>
    </Switch>
  );
}
